import "bootstrap/js/src/modal";
import AOS from "aos";

import "./topbar";
import "../styles/about.scss";

AOS.init();
